import axios from "axios";
import { STATUSES } from "./apiStatus";
import { base_url } from "../utils";
import { getAccesstoken } from "../helpers/utils";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const reportData = createAsyncThunk(
  "report/fetch",
  async ({ data, api }, { rejectWithValue }) => {
    try {
      const token = getAccesstoken();
      const response = await axios.post(`${base_url}/digilocker/${api}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const reportSlice = createSlice({
  name: "report",
  initialState: {
    data: {},
    status: STATUSES.IDLE,
    error: null,
  },
  reducers: {
    clearReportData: (state) => {
      state.data = [];
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(reportData.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(reportData.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(reportData.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
        state.error = action.payload;
      });
  },
});
export const { clearReportData } = reportSlice.actions;
export default reportSlice.reducer;
